/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { CommonEmail } from '../CommonEmail'

const previewData = {
  username: 'User',
  user_email: 'user@example.com',
  product_name: 'Crash Course',
  amount: 100,
  discount_code: 'BLACK_FRIDAY',
  invoice_url: 'https://www.google.com',
}

type Props = {
  platform: Platform
}

export const CrashCoursePurchased = ({ platform }: Props) => (
  <CommonEmail type={EmailTemplateTypeEnum.CrashCoursePurchased} platformId={platform.id} previewData={previewData} />
)
